import { Reveal, SectionLabel } from "./shared";

export const Purpose = () => (
  <section className="py-24 md:py-36" data-testid="purpose-section">
    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <Reveal>
        <SectionLabel testId="purpose-label">Our Purpose</SectionLabel>
        <h2
          className="font-heading text-3xl sm:text-4xl md:text-[2.75rem] font-semibold tracking-tight text-[#1F2043] leading-[1.15]"
          data-testid="purpose-headline"
        >
          A confident start to adulthood shouldn&rsquo;t depend on luck.
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="font-body mt-9 text-base md:text-lg font-light leading-relaxed text-[#3C3C3B]" data-testid="purpose-paragraph-one">
          Care leavers face a quiet crisis. When they turn 18 and step out of the only home
          they&rsquo;ve known, they walk into the world without a safety net, without the emotional
          readiness to handle setbacks, and often without anyone in their corner.
        </p>
        <p className="font-body mt-6 text-base md:text-lg font-light leading-relaxed text-[#3C3C3B]" data-testid="purpose-paragraph-two">
          Our work isn&rsquo;t about handing them skills and hoping for the best. It&rsquo;s about
          self-agency &mdash; the ability to pause, understand the options in front of them, and
          navigate life with awareness.
        </p>
      </Reveal>
    </div>
  </section>
);
